import { render, staticRenderFns } from "./CheckboxGroup.vue?vue&type=template&id=18e313d9&scoped=true&"
import script from "./CheckboxGroup.vue?vue&type=script&lang=ts&"
export * from "./CheckboxGroup.vue?vue&type=script&lang=ts&"
import style0 from "./CheckboxGroup.vue?vue&type=style&index=0&id=18e313d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e313d9",
  null
  
)

export default component.exports